import { render, staticRenderFns } from "./PageSwitchColumn.vue?vue&type=template&id=01df3226&scoped=true"
import script from "./PageSwitchColumn.vue?vue&type=script&lang=js"
export * from "./PageSwitchColumn.vue?vue&type=script&lang=js"
import style0 from "./PageSwitchColumn.vue?vue&type=style&index=0&id=01df3226&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01df3226",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
